<template>
  <v-btn v-bind="$attrs" v-on="$listeners">
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </v-btn>
</template>

<script>
export default {
  name: "ABtn",
};
</script>

<style scoped>
.v-size--small {
  height: 32px !important;
}

.v-size--default {
  height: 40px !important;
}

.v-size--x-small {
  height: 24px !important;
}

.primaryDark,
.primaryDark2 {
  color: #fff !important;
}

.secondary {
  color: var(--v-darkCharcoal-base) !important;
}

.v-btn.secondary /deep/ .v-btn__content .v-icon {
  color: var(--v-neutralGray-base) !important;
}

.primaryDark2--text {
  background-color: #edf8ff !important;
}

.v-btn.disabled-button.v-btn--disabled {
  color: var(--v-neutralGrayLight-base) !important;
}

.v-btn.disabled-button.v-btn--disabled.v-btn--has-bg {
  background-color: #cccccc !important;
}

.v-btn.disabled-button.v-btn--disabled /deep/ .v-icon {
  color: var(--v-neutralGrayLight-base)!important;
}

.v-btn {
  letter-spacing: 0 !important;
}
.up {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  margin-bottom: 1px;
}
.down {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

::v-deep .v-btn__content {
  font-family: "Noto Sans JP" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  text-transform: initial !important;
}

</style>